import { inject, provide } from 'vue'

export interface InsightsLayoutContext {
  inFloatingSidepane: boolean
}

export const INSIGHTS_LAYOUT_CONTEXT_KEY = 'insightsLayoutContext'

export function provideInsightsLayoutContext(
  context: InsightsLayoutContext
): void {
  provide(INSIGHTS_LAYOUT_CONTEXT_KEY, context)
}

export function useInsightsLayoutContext(): InsightsLayoutContext {
  return inject<InsightsLayoutContext>(
    INSIGHTS_LAYOUT_CONTEXT_KEY,
    () => ({ inFloatingSidepane: false }),
    true
  )
}
